/**
 * The colour background as a texture three draws through its background mesh, so under fog it
 * passes through the fog, as Godot fogs it in the fog-only sky pass
 * (`forward_clustered/render_forward_clustered.cpp:1996-2014`). three's clear skips the fog.
 */
import * as THREE from 'three';
import { sRGBToLinearRGB } from '../../utils/colorSpace';
/**
 * A 1x1 texture of the sRGB clear `color`, which already carries the background energy, linearised
 * once. A flat texture, not a cube: three draws it as a clip-space quad, which fills the view under
 * any camera, while its cube background is a unit box that an orthographic view covers only in part.
 * The caller disposes of it.
 */
export function clearColorTexture(color) {
    return linearTexture(sRGBToLinearRGB(color.r, color.g, color.b));
}
/**
 * The clear colour under fog, which Godot linearises twice: once as it sets the fog material's
 * `clear_color` (`:2014`), and once more because a sky material converts every Color parameter
 * (`environment/sky.cpp:193`, `material_storage.cpp:801`). Its brightness (`:2045`) applies the
 * energy again as `backgroundIntensity`. The caller disposes of it.
 */
export function foggedClearColorTexture(color) {
    return linearTexture(sRGBToLinearRGB(...sRGBToLinearRGB(color.r, color.g, color.b)));
}
/** Linear float texels with no mipmaps or filtering, so a channel above 1 reaches the curve as is. */
function linearTexture([r, g, b]) {
    const texture = new THREE.DataTexture(new Float32Array([r, g, b, 1]), 1, 1);
    texture.type = THREE.FloatType;
    texture.colorSpace = THREE.LinearSRGBColorSpace;
    texture.generateMipmaps = false;
    texture.minFilter = THREE.NearestFilter;
    texture.magFilter = THREE.NearestFilter;
    texture.needsUpdate = true;
    return texture;
}
//# sourceMappingURL=colorBackground.js.map